import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-88">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-89">
        <div className="flex items-center" data-id="element-90">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vwP82zAyS5YTdoZq7T5QTk/Screenshot_20250729-220251_Google.jpg" alt="MimiApp Logo" className="h-10 w-auto mr-2" data-id="element-91" />
          <h1 className="text-2xl font-bold text-emerald-800" data-id="element-92">MimiApp</h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6" data-id="element-93">
          <a href="#features" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-94">
            Features
          </a>
          <a href="#testimonials" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-95">
            Testimonials
          </a>
          <a href="#pricing" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-96">
            Pricing
          </a>
          <Button variant="outline" size="sm" data-id="element-97">
            Find a Therapist
          </Button>
          <Button size="sm" data-id="element-98">Download App</Button>
        </nav>
        {/* Mobile Navigation Toggle */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-99">
          {isMenuOpen ? <XIcon size={24} data-id="element-100" /> : <MenuIcon size={24} data-id="element-101" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-102">
          <nav className="flex flex-col space-y-4 py-4" data-id="element-103">
            <a href="#features" className="text-gray-700 hover:text-emerald-700 font-medium px-2 py-1" onClick={() => setIsMenuOpen(false)} data-id="element-104">
              Features
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-emerald-700 font-medium px-2 py-1" onClick={() => setIsMenuOpen(false)} data-id="element-105">
              Testimonials
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-emerald-700 font-medium px-2 py-1" onClick={() => setIsMenuOpen(false)} data-id="element-106">
              Pricing
            </a>
            <Button variant="outline" fullWidth data-id="element-107">
              Find a Therapist
            </Button>
            <Button fullWidth data-id="element-108">Download App</Button>
          </nav>
        </div>}
    </header>;
}